import React, { Component } from 'react'
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, Brush } from 'recharts'
import { COLORS, GRAPH_MARGIN } from '../utils/constants'
import * as formatter from '../utils/formatters'
import * as Request from '../service/data-info-chart/requestsUtil'
import * as cbu from '../utils/checkBusinessUnit'
import { DAILY_RECOVERY_ACUMMULATED, voidData } from '../utils/constants'

var Loader = require('react-loader')

export default class DailyAccumulatedIncome extends Component {

  constructor (props) {
    super(props)
    this.state = {data: [], month: '', date: this.props.date, loaded: false}
  }

  componentDidMount () {
    let params = {
      id: cbu.checkBusinessUnit(this.props.bu),
      date: this.state.date
    }

    Request.postFetch(DAILY_RECOVERY_ACUMMULATED, params)
      .then((data) => {
        this.setState({data: data.data, month: data.month, loaded: true})
      })
  }

  render () {

    return (
      <Loader loaded={this.state.loaded} top={'90%'}>
        <ResponsiveContainer>
          <LineChart width={1300} height={300} data={this.state.data} margin={GRAPH_MARGIN}>
            <XAxis dataKey="day"/>
            <YAxis tickFormatter={formatter.formatNumberMoney} scale={'linear'}/>
            <CartesianGrid/>
            <Tooltip formatter={formatter.formatNumberMoney}/>
            <Legend verticalAlign={'top'}/>
            <Line type="linear" name={'Ingreso'} dataKey="ammount" stroke={COLORS.GOAL}/>
          </LineChart>
        </ResponsiveContainer>
      </Loader>
    )
  }

}



// WEBPACK FOOTER //
// ./src/components/dailyAccumulatedIncome.js